(function () {
	'use strict';

	var markers = document.querySelectorAll('[data-read-more-paragraph]');
	var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

	if (!markers.length) {
		return;
	}

	markers.forEach(function (marker, index) {
		var button = marker.querySelector('.read-more-paragraph__toggle');
		var label = marker.querySelector('[data-read-more-label]');
		var content = document.createElement('div');
		var readMoreText = button ? button.getAttribute('data-read-more-text') : '';
		var readLessText = button ? button.getAttribute('data-read-less-text') : '';
		var expanded = false;
		var animation = null;

		if (!button || !marker.parentNode) {
			return;
		}

		content.className = 'read-more-paragraph__content';
		content.id = marker.id + '-content-' + index;
		marker.parentNode.insertBefore(content, marker.nextSibling);

		while (content.nextSibling) {
			content.appendChild(content.nextSibling);
		}

		button.setAttribute('aria-controls', content.id);
		marker.classList.add('is-initialised');

		function cancelAnimation() {
			if (animation) {
				animation.cancel();
				animation = null;
			}
		}

		function exposeContent() {
			content.removeAttribute('inert');
			content.setAttribute('aria-hidden', 'false');
			content.style.height = 'auto';
			content.style.visibility = 'visible';
		}

		function concealContent() {
			content.setAttribute('inert', '');
			content.setAttribute('aria-hidden', 'true');
			content.style.height = '0px';
			content.style.visibility = 'hidden';
		}

		function setExpanded(nextExpanded, shouldAnimate) {
			var startHeight;
			var endHeight;

			expanded = nextExpanded;
			button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
			label.textContent = expanded ? readLessText : readMoreText;
			cancelAnimation();

			if (!shouldAnimate || reducedMotionQuery.matches || !content.animate) {
				if (expanded) {
					exposeContent();
				} else {
					concealContent();
				}
				return;
			}

			content.style.visibility = 'visible';
			content.removeAttribute('inert');
			content.setAttribute('aria-hidden', expanded ? 'false' : 'true');
			startHeight = content.getBoundingClientRect().height;
			content.style.height = 'auto';
			endHeight = content.scrollHeight;
			content.style.height = startHeight + 'px';

			animation = content.animate(
				[
					{ height: startHeight + 'px' },
					{ height: (expanded ? endHeight : 0) + 'px' }
				],
				{ duration: 350, easing: 'ease-in-out' }
			);

			animation.onfinish = function () {
				animation = null;

				if (expanded) {
					exposeContent();
				} else {
					concealContent();
				}
			};
		}

		button.addEventListener('click', function () {
			setExpanded(!expanded, true);
		});

		setExpanded(false, false);
	});
})();
